__turbopack_context__.v({
  "closeButton": "JO76KW_closeButton",
  "dismissButton": "JO76KW_dismissButton",
  "installButton": "JO76KW_installButton",
  "promptActions": "JO76KW_promptActions",
  "promptContainer": "JO76KW_promptContainer",
  "promptContent": "JO76KW_promptContent",
  "promptDescription": "JO76KW_promptDescription",
  "promptIcon": "JO76KW_promptIcon",
  "promptText": "JO76KW_promptText",
  "promptTitle": "JO76KW_promptTitle",
  "slideUp": "JO76KW_slideUp",
});
